import { Component, OnInit,ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { WebParameterContext } from '../../../../model/common';
import {  IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { NativeService } from 'src/service/native.service';
declare var app;
@Component({
  selector: 'app-transfer-gifts-list-srl',
  templateUrl: './transfer-gifts-list-srl.component.html',
  styleUrls: ['./transfer-gifts-list-srl.component.scss']
})
export class TransferGiftsListSrlComponent extends GridBaseCase {
  gifsearchValue: any;// 搜索条件
  pageName: string;
  searchValue:any="";
  arrayData:Array<any>=[];
  erraMsg: any = null;
  uploadNum: any = [];
  PageNumber:number=0;
  RecordCount: Number = 0;//列表总数量
  apiObj = {
    status: false,
    msg: ''
};//接口状态
loading: boolean = false;//加载效果
month: any = new Date();
@ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    private native:NativeService,
  ) {
    super();
    // debugger;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(this.activaRouter.snapshot.queryParams.searchValue){
      this.searchValue=this.activaRouter.snapshot.queryParams.searchValue;
    };
    //赠品调货SRL列表添加
    this.baseService.FixedSubmitBtn.text = "添加调货计划";
    this.baseService.FixedSubmitBtn.configName = "TransferGiftsListSRL";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.type = 15;
    this.month = this.com.getNow;
  }
  ngAfterViewInit() {
    const that=this;
    that.LoadData(1);
   }
  // 搜索条件
  serarEvent(e, type: string = 'type') {
    const that = this;
    that.LoadData(1);
  }
    // 日期查询
    EventDateTimeClick(){
      console.log("测试1");
      let that = this;
      console.log(that.month);
      let _obj = {
        value:that.month,
        format:"yyyymmdd"
      };
      that.native.IosselectDateTime(_obj).then(data=>{
       that.month=that.formatDate(data.value);
       that.LoadData(1);
        console.log("测试");
      }).catch(eror=>{
      console.log(eror);
        });
    }
    // 日期查询转换方法
    formatDate(date){
      if(date){
        let _date = new Date(date.replace(/-/g,"/"));
        let _y = _date.getFullYear();
        let _m = _date.getMonth()+1;
        let _d = _date.getDate();
        return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
      }else{
        return date;
      }
    }

  /**
   * 
   * @param e 跳转页面
   */
  EventLink(item) {
    const that = this;
    that.com.setHistoryUrl(true);
    that.com.Go("/tabs/contact/TransferGiftsForm/edite/"+item.ID+"&"+that.com.getNowDatetime,{
          ID:item.ID,
          StoreName_In: item.StoreName_In,//调入门店名称
          StoreName_Out: item.StoreName_Out, // 调出门店名称
          CargoDateTime: item.CargoDateTime,// 日期
          FK_TBStore_ID_in: item.FK_TBStore_ID_in, // 调入门店id
          FK_TBStore_ID_out: item.FK_TBStore_ID_out,//调出门店id
          status:item.CargoState
    });
  }



  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.arrayData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    let _dy:any={}
   if(that.searchValue){
    _dy["StoreName"] = that.searchValue;
   }
   if(that.month){
    _dy["dataTime"] = that.month;
   }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName="TBGiftsCargoPlanXmlSRL";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber =1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "product";
    body.Client.ClientType = 0;
    body.RequestBody=JSON.stringify( _dy);
     
    that.http.post(app.DEFAULTURL, body).then(data => {
         /****判断是否第一页begin****/
         if(PageNumber == 1){
          that.arrayData = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          // that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        console.log(data.Status.Datas,"成功成功");
        data.Status.Datas.forEach(item=>{
          item.CargoDateTime=item.CargoDateTime.replace(/-/g,"/");
        });
        that.arrayData=data.Status.Datas;
        // that.arrayData.forEach(item=>{
        //   item.ChineseName=that.com.FormatName(item.ChineseName||"");
        //   item.Mobile=that.com.PhoneNum(item.Mobile||"");
        // });
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.arrayData.length){
            that.infiniteScroll.disabled = true;
          }else{
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
      }
 
    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
/**
 * 添加调货计划
 * @param item 
 */
  EventSubmitClick(item){
    const that=this;
    that.com.setHistoryUrl(true);
    that.com.Go("/tabs/contact/TransferGiftsForm/add/"+that.com.getNowDatetime);
  }

}
